module.exports = __webpack_public_path__ + "light-close.png?c1b43adb6a63a1c158216808d88e92b3";